import {
  ProductSummaryTO,
  ResourceFees,
  SelectedOptionsTO,
  SubscriptionPlanTO,
} from '../../CloudAddToCartButton/common/types';
import { Periods } from '../../interfaces/QuoteItem.types';

function getSubscriptionOptions(
  allOptions: ProductSummaryTO[],
  selectedOptions: SelectedOptionsTO[]
) {
  const response = selectedOptions.map((selectedOption) => {
    const option = allOptions?.find(
      (opt: any) =>
        opt.subscriptionOption?.resourceApsId ===
          selectedOption.option?.resourceApsId ||
        opt.subscriptionOption?.parentSubscriptionPlan?.planApsID ===
          selectedOption.option?.resourceApsId
    );
    if (!option) {
      return null;
    }
    const subscriptionOption = option?.subscriptionOption;
    const subscriptionOptionResource = subscriptionOption?.resources?.find(
      (resource) => resource.resourceId === selectedOption.option?.resourceApsId
    );
    const optionFees = subscriptionOptionResource?.fees?.map((fee) => {
      const newFee: ResourceFees = {
        code: fee.code,
        msrp: fee.msrp ? parseFloat(fee.msrp.toString()) : 0,
        price: fee.price ? parseFloat(fee.price.toString()) : 0,
        type: fee.type,
      };
      return newFee;
    });

    const recurringPriceModel = subscriptionOption?.setupFees
      ? 'FLAT - SETUP FEES'
      : subscriptionOptionResource?.recurringpricemodel;
    const recurringTiers = subscriptionOptionResource?.recurringTiers || [];
    const subscription = subscriptionOption?.parentSubscriptionPlan;
    return {
      billingPeriods: {
        Duration: subscription?.billingPeriod,
        unit: subscription?.billingPeriodUnit,
      } as Periods,
      duplicateselected: false,
      fees: optionFees || [],
      finSystemProfile: '0',
      harmonizedCode: option?.harmonizedCode,
      imageUrl:
        subscriptionOption?.parentSubscriptionPlan?.subscriptionGroupImage,
      isCloudProduct: true,
      lineId: '',
      longdescription:
        subscriptionOption?.description || subscriptionOption?.title,
      markUp: null,
      markUpUnit: null,
      planApsid: subscription?.planApsID,
      planId: subscription?.planId,
      planName: subscription?.title,
      pricingSource: subscriptionOption?.pricingSource,
      quantity: option.subscriptionOption?.minUnits?.toString(),
      recurringPriceModel,
      remainingQuantity: 0,
      resourceApsId: subscriptionOption?.resourceApsId,
      resourceId: subscriptionOption?.resourceId,
      shortDescription: subscriptionOption?.title,
      subscriptionPeriods: {
        Duration: subscription?.selectedSubscriptionPeriod?.split(' ')?.[0],
        unit: subscription?.selectedSubscriptionPeriod?.split(' ')?.[1],
      } as Periods,
      units: {
        included: option?.subscriptionOption?.includedUnits,
        max: option?.subscriptionOption?.maxUnits,
        min: option?.subscriptionOption?.minUnits,
      },
      vendorNumber: option?.subscriptionOption?.xVendorCode,
      vpn: subscriptionOption?.vpn,
      ...(recurringTiers &&
        recurringTiers?.length > 0 && {
          recurringTiers,
        }),
    };
  });
  return response.filter((option) => !!option);
}

export function subscriptionAddtoQuoteBody(
  allOptions: any,
  selectedOptions: SelectedOptionsTO[]
) {
  const subscriptionPlan: SubscriptionPlanTO =
    allOptions[0]?.subscriptionOption?.parentSubscriptionPlan;

  const subscriptionPeriod =
    subscriptionPlan?.selectedSubscriptionPeriod ||
    subscriptionPlan?.subscriptionPeriodSummary?.[0];
  const obj = {
    billingPeriods: {
      Duration: subscriptionPlan?.billingPeriod,
      unit: subscriptionPlan?.billingPeriodUnit,
    } as Periods,
    planApsid: subscriptionPlan?.planApsID,
    planId: subscriptionPlan?.planId,
    planName: subscriptionPlan?.title,
    remainingQuantity: 0,
    serviceTemplateId: subscriptionPlan?.serviceTemplateId || '',
    subscriptionOptions: getSubscriptionOptions(allOptions, selectedOptions),
    subscriptionPeriods: {
      Duration: subscriptionPeriod?.split(' ')?.[0],
      unit: subscriptionPeriod?.split(' ')?.[1],
    } as Periods,
  };
  return obj;
}

export function getCMPToken() {
  const jsonToken = localStorage.getItem('cmp-token-storage');
  if (jsonToken) {
    const cmpTokenData = JSON.parse(jsonToken);
    return cmpTokenData.access_token;
  }
  return undefined;
}
